"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var AddUserIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M22.998 11.81a7.23 7.23 0 00-5.248-2.248c-.856 0-1.678.149-2.44.422a5.343 5.343 0 10-9.621 2.55c-2.08.614-3.403 1.74-4.002 3.299A10.968 10.968 0 011 12C1 5.928 5.928 1 12 1c6.009 0 10.897 4.826 10.998 10.81z",
    opacity: ".6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.751 22.861c-.57.092-1.155.139-1.751.139-3.53 0-6.673-1.665-8.686-4.253v-.664c0-1.868 1.031-3.866 6.686-3.866.34 0 .663.007.97.02-.304.8-.47 1.669-.47 2.575a7.243 7.243 0 003.251 6.05zM10 12.721a3.343 3.343 0 110-6.686 3.343 3.343 0 010 6.686zM17.75 22a5.25 5.25 0 110-10.5 5.25 5.25 0 010 10.5zm1-6.188v-2.437h-2v2.438h-2.438v2h2.438v2.437h2v-2.438h2.438v-2H18.75z"
  })));
});
AddUserIcon.category = 'Profile';
var _default = AddUserIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/AddUserIcon.js
// module id = 1039
// module chunks = 0